import { lazy } from 'solid-js'
import environment from '../../../../.configs/app/environment.js'
import { messages } from '../../pages/test-page/test-page-routing.messages.en.js'

const testRoute = {
    component: lazy(() => import('../../pages/test-page/test-page.jsx')),
    path: '/components',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: false,
    titleMessage: messages.titleMessage,
}

// Export route only in dev/qa environments
export default (environment.app.env === 'development' || environment.app.env === 'workstation' || environment.app.env.includes('qa') ) ? testRoute : null
